let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1CoPT")).then(() => parcelRequire('1iMx3'));